import { Container, Grid } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import SpotCard from "./Component/Widgets/SpotCard";
import TableSpot from "./Component/TableWallet/TableSpot";
import WalletTabs from "./Component/WalletTabs";
import useIsMobileView from "hooks/useIsMobileView";

const actionItems = [
  {
    value: "/deposit/1",
    text: "Deposit",
  },
  { value: "/withdraw/1", text: "Withdraw" },
  {
    value: {
      key: "transfer",
      extra: { transferSideId: 2 },
    },
    text: "Transfer",
  },
];

export function Wallet() {
  const isMobileView = useIsMobileView();
  const navigate = useNavigate();

  // eslint-disable-next-line no-unused-vars
  const [_, setSearchParams] = useSearchParams();

  const handleClickOnItems = (page) => {
    if (page.key) {
      const defaultCoin = 1;
      setSearchParams({ [page?.key || page]: defaultCoin, ...page?.extra });
    } else {
      navigate(page);
    }
  };

  return (
    <Container maxWidth="100%">
      <Grid container>
        {isMobileView && <WalletTabs />}

        <SpotCard buttonItems={actionItems} buttonOnChange={handleClickOnItems} />

        <Grid item xs={12} mt={2}>
          <TableSpot />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Wallet;
